module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_06.de98a423.jpg";